<template >
  <v-card class="pa-3" height="100%">
    <v-sheet v-if="isLoading">
      <v-skeleton-loader
        class="mx-auto"
        max-width="300"
        type="image, divider, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line "
      />
    </v-sheet>
    <v-dialog v-model="chgimg" max-width="40%">
      <v-card>
        <v-card-title>
          <span class="headline">Change Picture</span>
        </v-card-title>
        <form enctype="multipart/form-data">
          <v-file-input
            class="pa-4"
            label="Upload image"
            filled
            prepend-icon="mdi-camera"
            accept="image/*"
            @change="imgSelected"
          ></v-file-input>

          <v-card-actions>
            <v-btn color="blue darken-1" text @click="saveImg()"
              >Update Profile Picture</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <v-container v-show="!isLoading" fluid>
      <div class="d-flex justify-center">
        <v-badge bordered bottom color="green" offset-x="35" offset-y="20">
          <v-hover>
            <template v-slot:default="{ hover }">
              <v-avatar size="120" >
                <img
                  :lazy-src="profileimg"
                  :src="profileimg"
                  alt="Profile Image"
                >
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute color="#036358">
                    <v-btn small @click="chgImg()"
                      ><span class="change-btn"> Change Picture</span>
                    </v-btn>
                  </v-overlay>
                </v-fade-transition>
              </v-avatar>
            </template>
          </v-hover>
        </v-badge>
      </div>

      <v-layout d-block text-center class="mt-2 mb-1">
        <h3 class="subtitle-3 ">{{ client.Name}}</h3>
        <!-- <h5 class="subtitle-2">{{ employee.Position }}</h5> -->

        <v-btn 
          depressed 
          color="primary" 
          block 
          class="mt-2" 
          :to="'/communication/'+clientID"
        >
          
          Communication Log
        </v-btn>
        <v-btn
          icon
          @click="show = !show"
          class="hidden-sm-and-up mt-2"
        >
          <v-icon large>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </v-layout>

      <div class="hidden-sm-and-down">
      <v-divider class="mt-5"></v-divider>
      <v-card-text class="text-overline text-h1">Date of Birth</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="text-md-subtitle-2">
          {{ birthdate }}
        </div>
      </v-card-title>
      <v-card-text class="text-overline">PID</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="text-md-subtitle-2">
          {{ client.PID }}
        </div>
      </v-card-title>
      <v-card-text class="text-overline">Case Number</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="text-md-subtitle-2">
          {{ client.Case }}
        </div>
      </v-card-title>
      <v-card-text class="text-overline" v-if="client.State == 'Nevada'">Wellsky</v-card-text>
      <v-card-title class="mt-n2 mb-2" v-if="client.State == 'Nevada'">
        <div class="text-md-subtitle-2">
          {{ client.Wellsky }}
        </div>
      </v-card-title>
      <v-card-text class="text-overline">Program</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="text-md-subtitle-2">
          <span
            v-for="(program, index) in client.Program"
            :key="index"
          > {{ program }} <br v-if="index !== client.Program.length - 1"></span>
        </div>
      </v-card-title>
    <v-card-text class="text-overline">Service Code</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="text-md-subtitle-2">
          <span
            v-for="code in client.ServiceCode"
            :key="code._id"
            > {{ code.ServiceCode }} </span>
        </div>
      </v-card-title>
    <v-card-text class="text-overline">Behaviors</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="text-md-subtitle-2">
        <span
          v-for="behav in client.Behaviors"
          :key="behav._id"
        > {{ behav.Behavior }},</span>
        </div>
      </v-card-title>
    <v-card-text class="text-overline" >Medicare #</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="text-md-subtitle-2">
          {{client.Medicare }}
        </div>
      </v-card-title>
    <v-card-text class="text-overline">Medicaid #</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="text-md-subtitle-2">
        <!-- <span
            v-for="allergy in allergies"
            :key="allergy._id"
          > {{allergy.Allergy}} </span> -->
          {{client.Medicaid}}
        </div>
      </v-card-title>    
    <v-card-text class="text-overline">Diagnosis</v-card-text>
      <v-card-title class="mt-n2 mb-2" width="100%">
        <div class="text-md-subtitle-2">
          <v-row>
            <v-card flat>
              <v-container max-width="100%" class="mr-n1 ml-n1">
                <v-list >
                  <v-list-item
                    v-for="diag in compDiagnoses"
                    :key="diag._id"
                    class="px-0"
                  >
                    <v-card-text>
                      {{ diag.Diagnosis }} 
                      <v-divider></v-divider>
                    </v-card-text >
                  </v-list-item>
                </v-list>

                <v-expand-transition>
                  <v-list v-if="isShowDiagnoses" class="ma-0 pa-0">
                    <v-list-item
                      v-for="diag in diagnoses"
                      :key="diag._id"
                      class="px-0"
                    >
                      <v-card-text >
                        {{ diag.Diagnosis }} 
                        <v-divider></v-divider>
                      </v-card-text>
                    </v-list-item>
                  </v-list>
                </v-expand-transition>

                 <v-card-text v-if="diagnoses.length >= 1">
                   <a color="#BBDEFB" @click="showDiagnoses">{{isShowDiagnoses ? 'Show Less' : 'Show More'}}</a>
                </v-card-text>
              </v-container>
            </v-card>
          </v-row>
        </div>
      </v-card-title>
      </div>
      <v-expand-transition class="hidden-sm-and-up">
        <div v-show="show">
          <v-divider class="mt-5"></v-divider>
          <v-card-text class="text-overline text-h1">Date of Birth</v-card-text>
          <v-card-title class="mt-n2 mb-2">
            <div class="text-md-subtitle-2">
              {{ birthdate }}
            </div>
          </v-card-title>
          <v-card-text class="text-overline">PID</v-card-text>
          <v-card-title class="mt-n2 mb-2">
            <div class="text-md-subtitle-2">
              {{ client.PID }}
            </div>
          </v-card-title>
          <v-card-text class="text-overline">Case Number</v-card-text>
          <v-card-title class="mt-n2 mb-2">
            <div class="text-md-subtitle-2">
              {{ client.Case }}
            </div>
          </v-card-title>
          <v-card-text class="text-overline" v-if="client.State == 'Nevada'">Wellsky</v-card-text>
          <v-card-title class="mt-n2 mb-2" v-if="client.State == 'Nevada'">
            <div class="text-md-subtitle-2">
              {{ client.Wellsky }}
            </div>
          </v-card-title>
          <v-card-text class="text-overline">Program</v-card-text>
          <v-card-title class="mt-n2 mb-2">
            <div class="text-md-subtitle-2">
              {{ client.Program }}
            </div>
          </v-card-title>
        <v-card-text class="text-overline">Service Code</v-card-text>
          <v-card-title class="mt-n2 mb-2">
            <div class="text-md-subtitle-2">
              <span
                  v-for="code in codes"
                  :key="code._id"
                > {{ code.ServiceCode }} </span>
            </div>
          </v-card-title>
        <v-card-text class="text-overline">Behaviors</v-card-text>
          <v-card-title class="mt-n2 mb-2">
            <div class="text-md-subtitle-2">
            <span
              v-for="behav in behaviors"
              :key="behav._id"
            > {{ behav.Behavior }},</span>
            </div>
          </v-card-title>
        <v-card-text class="text-overline" >Medicare #</v-card-text>
          <v-card-title class="mt-n2 mb-2">
            <div class="text-md-subtitle-2">
              {{client.Medicare }}
            </div>
          </v-card-title>
        <v-card-text class="text-overline">Diagnoses</v-card-text>
          <v-card-title class="mt-n2 mb-2">
            <div class="text-md-subtitle-2">
              <v-row>
                <v-card flat>
                  <v-container width="100%" class="mr-n1 ml-n1">
                    <v-list >
                      <v-list-item
                        v-for="diag in compDiagnoses"
                        :key="diag._id"
                        class="px-0"
                      >
                        <v-card-text>
                        {{ diag.Diagnosis }} 
                         <v-divider></v-divider>
                        </v-card-text >
                      </v-list-item>
                    </v-list>

                    <v-expand-transition>
                      <v-list v-if="isShowDiagnoses" class="ma-0 pa-0">
                        <v-list-item
                          v-for="diag in client.Diagnoses"
                          :key="diag._id"
                          class="px-0"
                        >
                          <v-card-text >
                            {{ diag.Diagnosis }} 
                            <v-divider></v-divider>
                          </v-card-text>
                        </v-list-item>
                      </v-list>
                    </v-expand-transition>

                    <v-card-text v-if="diagnoses.length >= 1">
                      <a color="#BBDEFB" @click="showDiagnoses">{{isShowDiagnoses ? 'Show Less' : 'Show More'}}</a>
                    </v-card-text>
                  </v-container>
                </v-card>
              </v-row>
            </div>
          </v-card-title>
      </div> 
    </v-expand-transition>

    </v-container>
  </v-card>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import moment from "moment";
import { mapActions } from "vuex";

const url = require("../client_config/config").url;

export default {
  components: {
  },
  data: () => ({
    client: [],
    behaviors: [],
    admissionDate: "",
    birthdate: "",
    chgimg: false,
    overlay: false,
    uploadImg: "",
    profileimg: "",
    clientID: localStorage.getItem("clientId"),
    tempData: [],
    diagnoses: [],
    allergies: [],
    codes: [],
    isLoading: true,
    dialog: false,
    show: false,
    isShowDiagnoses: false,
    limit: 5 

  }),

  computed: {
    
    compDiagnoses(){
      let diagnoses = this.client?.Diagnoses
      return diagnoses?.splice(0, this.limit)
    }
    
  },

  created() {
    // this.clientID = (  this.clientID === null ?  this.$route.params.clientID :  localStorage.getItem("clientId") );
    this.clientID = this.$route.params.clientID;
    this.getClient(this.clientID);
  },

  methods: {

    ...mapActions({
      getClientInfo: "clients/getClient",
    }),


    initialize() {
      this.client = [];
    },

    async getClient() {
      try {
        let response = await this.getClientInfo(this.clientID);
        this.client = response;
        this.admissionDate = this.client?.AdmissionDate != null ? moment(new Date(this.client?.AdmissionDate)).format("MM/DD/YYYY") : '';
        this.birthdate = moment(this.client.Birthday).format("MM/DD/YYYY") 
        this.profileimg = this.client.Image;
      } catch (error) {
        console.log(error)
      }finally{
        this.isLoading = false
      }
    },


    showDiagnoses(){
      this.isShowDiagnoses = !this.isShowDiagnoses
    },

    close() {
      this.seditInfo = false;
      this.passdialog = false;
      this.chgimg = false;
    },

    chgImg() {
      this.chgimg = true;
    },

    imgSelected(e) {
      this.uploadImg = e;
    },

    saveImg() {
      //console.log(this.uploadImg)
      const formData = new FormData();
      formData.append("profile-img", this.uploadImg);
      var ct = { headers: { "content-type": "multipart/form-data" } };
      axios
        .post(`${url}/clients/imguploader/${this.clientID}`, formData, ct)
        .then((res) => {
          //this.profileimg = '/uploads/'+res.data.file.filename;
          this.close();
          this.getClient(this.clientID);
          this.text =
            "The account profile picture has been updated successfully.";
          this.msg = true;
          if (res) {
            console.log();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getClientData(){
      return this.client
    }
  },
};
</script>
<style scoped>
@media only screen and (max-width: 480px) {
  .v-sheet.v-card#card {
    max-height: 500px;
  }

  .v-sheet.v-card {
    display: none;
  }

  .inline {
    display: inline-block;
  }

  #card {
    display: none;
  }

  .v-card__text {
    width: 100%;
  }
}

.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 5px;
}

.v-application .client-details-font {
  font-size: 0.9rem !important;
}

.col-padding {
  padding: 0px 10px;
}

.col-mt {
  margin-top: -20px;
}
</style>
